import React from 'react';

import Illustration from '../illustration/Illustration';
import { Container, HelpCenter, Subtitle, TextContainer, Title, Wrapper } from './styles';

interface PaywallProps {
  illustration: any;
  title: string;
  subtitleText: string;
}

const PaywallComponent: React.FC<PaywallProps> = ({ illustration, title, subtitleText }) => {
  return (
    <Wrapper>
      <Container>
        <Illustration name={illustration} />
        <TextContainer>
          <Title>{title}</Title>
          <Subtitle>{subtitleText}</Subtitle>
          <span>
            Precisa de Ajuda? Entre em contato com a{' '}
            <HelpCenter href="https://no.descomplica.com.br/knowledge/empresas">
              Central de ajuda.
            </HelpCenter>
          </span>
        </TextContainer>
      </Container>
    </Wrapper>
  );
};

export default PaywallComponent;
